import { render, staticRenderFns } from "./PopupAIRiskRecommendation.vue?vue&type=template&id=fefcf206&scoped=true"
import script from "./PopupAIRiskRecommendation.vue?vue&type=script&lang=js"
export * from "./PopupAIRiskRecommendation.vue?vue&type=script&lang=js"
import style0 from "./PopupAIRiskRecommendation.vue?vue&type=style&index=0&id=fefcf206&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fefcf206",
  null
  
)

export default component.exports